import {HTTP} from "@/helpers/http-common"
import * as R from "ramda";

const get = (usuario) =>new Promise((resolve,reject)=>{
  const {username} = usuario;
  HTTP.get(
    `/api/usuario/${username}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const save = (usuario) =>new Promise((resolve,reject)=>{
  const {username
    , nombre
    , telefono
    , interno
    , celular
    , correoElectronico
    , comercio
    , enabled, activo
    , foto} = usuario;
    //foto_miniatura 40px 40px
  HTTP
  .post(
    '/api/usuario'
    , {username
      , nombre
      , telefono
      , interno
      , celular
      , correoElectronico
      , comercio
      , enabled, activo
      , foto
      , foto_miniatura:foto}
  ).then(response=>{
    console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const update = (usuario) =>new Promise((resolve,reject)=>{
  const {username
    , nombre
    , telefono
    , interno
    , celular
    , correoElectronico
    , comercio
    , enabled, activo
    , foto
    , foto_miniatura} = usuario;
  HTTP
  .put(
    '/api/usuario'
    , {username
      , nombre
      , telefono
      , interno
      , celular
      , correoElectronico
      , comercio
      , enabled, activo
      , foto
      , foto_miniatura}
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const disable = (usuario) =>new Promise((resolve,reject)=>{
  const {username:username} = usuario;
  HTTP
  .delete(
    "/api/usuario/"
    , {
      params:{username}
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const getPerfiles = usuario => new Promise((resolve,reject)=>{
  const {username} = usuario;
  HTTP.get(
    `/api/usuariosPerfiles/${username}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const addPerfil = usuario => new Promise((resolve,reject)=>{
  const {group_id , username } = usuario;
  HTTP
  .post(
    '/api/usuariosPerfiles'
    , {
      group_id:{
        id:group_id
      }
      , username
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const removePerfil = usuario =>new Promise((resolve,reject)=>{
  const {group_id , username } = usuario;
  HTTP
  .delete(
    "/api/usuariosPerfiles"
    , {
      params:{
        group_id
        , username
      }
    }
  ).then((response)=>{
    resolve(response)
  })
  .catch((error)=>{
    reject(error)
  });
});


const resetPassword = (username) =>new Promise((resolve,reject)=>{
  HTTP
  .get(
    `/api/usuario/resetPassword/${username}`
  ).then(response=>{
    console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const updateStatus = (usuario) =>new Promise((resolve,reject)=>{
  const {username,enabled} = usuario;
  HTTP
  .put(
    `/api/usuario/${username}/${enabled}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

//Export methods
export default {
  get
  , save
  , update
  , disable
  , getPerfiles
  , addPerfil 
  , removePerfil 
  , resetPassword
  , updateStatus
}





// WEBPACK FOOTER //
// ./src/services/seguridad/usuario/index.js